<script setup>
import { 
	ref, 
	onUnmounted,
	nextTick
} from 'vue'
import { Notify } from '@/modules/util/notify'

const TIMEOUT = 2000
let timeoutId = null

const typeToColor = {
	'error': 'error',
	'info': 'info',
	'success': 'success',
	'warning': 'warning',
	'default': 'primary',
}

const alert = ref(false)
const message = ref('')
const color = ref('primary')
const queue = []

const checkQueue = () => {
	alert.value = false
    
	if (!queue.length) {
		timeoutId = null
		return
	}

	nextTick(() => {
		alert.value = true
	})

	if (queue.length > 3) {
		queue.splice(0, queue.length - 3)
	}

	const { type, msg } = queue.shift()

	message.value = msg
	color.value = typeToColor[type]

	timeoutId = setTimeout(() => {
		checkQueue()
	}, TIMEOUT + 100)
}

const onClose = () => {
	clearTimeout(timeoutId)
	checkQueue()
}

Notify.subscribe((type, msg) => {
	queue.push({ type, msg })
    
	if (!timeoutId) {
		checkQueue()
	}
})

onUnmounted(() => {
	clearTimeout(timeoutId)
})
</script>

<template>
<v-snackbar
	v-model="alert"
	:color="color"
	:timeout="TIMEOUT"
>
	{{ message }}
	<template #actions>
		<v-btn
			variant="text"
			@click="onClose"
		>
			Close
		</v-btn>
	</template>
</v-snackbar>
</template>

<style lang="scss" scoped>

</style>